import {ScreenConnectionWithTransportParams} from "./screen-connection-with-transport-params";

export class FreighterScreenConnection extends ScreenConnectionWithTransportParams {
  screenName = 'freighter_screen';
}
